export enum RootEnum {
  REMOTE,
  READ,
  READ_WRITE,
  U1,
  U2,
  ADMIN,
}
